import tw from 'tailwind-styled-components'

const CenterContainerComponent = tw.main`flex h-7/12 items-center justify-center`

export default CenterContainerComponent
